import React from 'react';
import css from './cappa-components.module.css';
import PreviewImage from './assets/profile-preview.png';
import { FormattedMessage } from 'react-intl';

const LandingProfileSection = () => {
  return (
    <div className={css.profileRoot}>
      <div className={css.profilePreview}>
        <img src={PreviewImage} alt="Profile Preview" />
      </div>
      <div className={css.profileContent}>
        <div className={css.profileTopContent}>
          <div className={css.profileAboveTitleText}>
            <FormattedMessage
              id="LandingPage.cappaComponents.profileAboveTitleText"
              defaultMessage={'Find your perfect Care team'}
            />
          </div>
          <div className={css.profileTitle}>
            <FormattedMessage
              id="LandingPage.cappaComponents.profileTitle"
              defaultMessage={'Compassionate care for your pregnancy journey.'}
            />
          </div>
        </div>
        <div className={css.profileBelowTitleText}>
          <FormattedMessage
            id="LandingPage.cappaComponents.profileBelowTitleText"
            defaultMessage={
              'Every pregnancy is unique, and having the right support makes all the difference. Browse experienced care proffesionals, read real reviews, and choose the one that fits your needs best. Your journey to a more confident and supported birth experience starts here.'
            }
          />
        </div>
      </div>
    </div>
  );
};

export default LandingProfileSection;
